import { Trans } from '@lingui/react/macro';
import Message from 'carbon-react/lib/components/message';

interface ErrorMessageProps extends React.ComponentProps<typeof Message> {
  error: unknown;
}

const ErrorMessage = (props: ErrorMessageProps) => {
  const { error, ...messageProps } = props;
  return (
    <Message open variant="error" {...messageProps}>
      <Trans>Something went wrong. Please try again.</Trans>
      {import.meta.env.NODE_ENV !== 'production' && <pre>{JSON.stringify(error, null, 2)}</pre>}
    </Message>
  );
};
export default ErrorMessage;
